import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageServices,
  DeleteServices,
  EditServices,
  GetServices,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { useNavigate } from 'react-router-dom';
import { RouterName } from 'src/routes/RouterName';

const Services = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    image: Yup.mixed().required("Image is required"),
    short_desc: Yup.string().trim().required("Short description is required"),
    full_desc: Yup.string().trim().required("Full description is required"),
    slug: Yup.string().trim().required("Slug is required"),
    meta_key: Yup.string().trim().required("Meta key is required"),
    meta_desc: Yup.string().trim().required("Meta description is required"),
    page_title: Yup.string().trim().required("Page title is required"),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetServices({
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
          } else {
            setData([]);
          }
          if (array.length == 0) {
            setarray([
              {
                failed: "id",
                type: inputType.text,
                title: "id",
                placeholder: "",
                fullwidth: true,
                customdesign: { display: "none" },
              },
              {
                failed: "title",
                type: inputType.text,
                title: "Title",
                placeholder: "Enter title",
                fullwidth: true,
              },
              {
                failed: "short_desc",
                type: inputType.text,
                title: "Short Description",
                placeholder: "Enter short description",
                fullwidth: true,
              },
              {
                failed: "full_desc",
                type: inputType.text,
                title: "Full Description",
                placeholder: "Enter full description",
                fullwidth: true,
              },
              {
                failed: "image",
                type: inputType.image,
                title: "Image",
                placeholder: "Upload image",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "slug",
                type: inputType.text,
                title: "Slug",
                placeholder: "Enter slug",
                fullwidth: true,
              },
              {
                failed: "meta_key",
                type: inputType.text,
                title: "Meta Key",
                placeholder: "Enter meta key",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "meta_desc",
                type: inputType.text,
                title: "Meta Description",
                placeholder: "Enter meta description",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "page_title",
                type: inputType.text,
                title: "Page Title",
                placeholder: "Enter page title",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
            ]);
          }
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "title" },
    { type: columntype.text, name: "short_desc" },
    { type: columntype.text, name: "full_desc" },
    {
      type: columntype.image,
      name: "image",
      options: {
        width: 100,
        height: 100
      }
    },
    { type: columntype.text, name: "slug" },
    { type: columntype.text, name: "meta_key" },
    { type: columntype.text, name: "meta_desc" },
    { type: columntype.text, name: "page_title" },
  ];
  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: true,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "short_desc",
      numeric: false,
      disablePadding: false,
      label: "Short Description",
      withSort: false,
    },
    {
      id: "full_desc",
      numeric: false,
      disablePadding: false,
      label: "Full Description",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "slug",
      numeric: false,
      disablePadding: false,
      label: "Slug",
      withSort: false,
    },
    {
      id: "meta_key",
      numeric: false,
      disablePadding: false,
      label: "Meta Key",
      withSort: false,
    },
    {
      id: "meta_desc",
      numeric: false,
      disablePadding: false,
      label: "Meta Description",
      withSort: false,
    },
    {
      id: "page_title",
      numeric: false,
      disablePadding: false,
      label: "Page Title",
      withSort: false,
    },
    (dataPrivileges["3"]?.access_edit == 1 ||
      dataPrivileges["3"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];
  const List = [
    dataPrivileges["3"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.username ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteServices({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["3"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
    {
      name: "Media",
      function: async (data) => {
        navigate(`/media/service/${data.id}`);
      },
    }
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditServices({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteServices({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["3"]?.access_write == 1 ? true : false}
        withDeleteItem={dataPrivileges["3"]?.access_delete == 1 ? true : false}
        withEditItem={dataPrivileges["3"]?.access_edit == 1 ? true : false}
        withPagination={false}
        withSearch={false}
        nameTable={`Services`}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Services"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new service"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            console.log({ valuess123323: valuess });
            dispatch(
              ManageServices({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default Services;
